import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Amplify from "@aws-amplify/core";
import aws_exports from "./aws-exports";
import { StoreProvider } from "./context/StoreContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./i18n/config";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
// config for Amplify
Amplify.configure(aws_exports);
// set default logger level
Amplify.Logger.LOG_LEVEL = "DEBUG";

ReactDOM.render(
  <Suspense fallback={<div></div>}>
    <StoreProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <App />
        </Router>
      </QueryClientProvider>
    </StoreProvider>
  </Suspense>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
